import React from "react";

//UI Material
import { Grid } from "@mui/material";

//Local Components
import UserProfile from "../Components/user-profile-page/UserProfile";

export default function Profile() {
  // ==========>Component States<==========
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));

  // ==========> Component <==========
  return (
    <Grid container justifyContent="center" textAlign="center" spacing={2}>
      <Grid item xs={12} align="center">
        <UserProfile userData={userData} />
      </Grid>
    </Grid>
  );
}
